export default __webpack_public_path__ + "static/media/logo-sm-light.b03c18da.png";